<div class="header horizontal-shadow dark" [class.shadow-visible]="isScrolled">
  <img class="logo" ngSrc="assets/fit-logo-mono.svg" height="29" width="60" alt="FIT Logo">
  <div class="menu">
    <img class="logo-with-text" src="assets/fit-logo-mono-text.svg" alt="Financial Intelligence Tool logo"
      height="35.676">
      <button class="close-menu" (click)="close()" aria-label="Close the menu">
        <svg-icon key="close"></svg-icon>
      </button>
    </div>
  </div>

  <div class="wrapper"
    overlay-scrollbars [defer]="true" [options]="osLight"
    waIntersectionObserver waIntersectionRoot
    >
    <div class="scroll-detect" (waIntersectionObservee)="isScrolled = !$event[0].isIntersecting"></div>
    <div class="navigation">
      <nav aria-label="explore">
        <ul class="pages">
          <li>
            <a [routerLink]="[{ outlets: { primary: ['explore'], actionbar: null}}]"
              routerLinkActive="active-page" [routerLinkActiveOptions]="{exact: true}" (click)="close()">
              <svg-icon key="explore"></svg-icon>
              Explore
            </a>
          </li>
          <li>
            <a [routerLink]="[{ outlets: { primary: ['explore','government'], actionbar: null}}]"
              routerLinkActive="active-page" (click)="close()">
              <svg-icon key="location"></svg-icon>
              Individual Governments
            </a>
          </li>
          <li>
            <a [routerLink]="[{ outlets: { primary: ['explore','government-type'], actionbar: null}}]"
              routerLinkActive="active-page" (click)="close()">
              <svg-icon key="gov-type"></svg-icon>
              Government Types
            </a>
          </li>
          <li>
            <a [routerLink]="[{ outlets: { primary: ['explore','dollars'], actionbar: null}}]"
              routerLinkActive="active-page" (click)="close()">
              <svg-icon key="finances"></svg-icon>
              Navigate By Dollars
            </a>
          </li>
          <li>
            <a [routerLink]="[{ outlets: { primary: ['explore','financial-health'], actionbar: null}}]"
              routerLinkActive="active-page" (click)="close()">
              <svg-icon key="health"></svg-icon>
              Financial Health
            </a>
          </li>
          <!--				<li>-->
          <!--					<a routerLink="/explore/filing-statistics" routerLinkActive="active-page" (click)="close()">-->
          <!--						<svg-icon key="filing"></svg-icon>-->
          <!--						Filing Statistics-->
        <!--					</a>-->
      <!--				</li>-->
    </ul>

    <hr>

      <!-- actions for mobile in lieu of header actions -->
      <ul class="actions">
        <!--				<li>-->
        <!--					<a [routerLink]="[]" (click)="close()">-->
        <!--						<svg-icon key="settings"></svg-icon>-->
        <!--						Settings-->
      <!--					</a>-->
    <!--				</li>-->
    @if (!user?.claim?.contactID) {
      <li>
        <a [routerLink]="[{ outlets: { primary: [], actionbar: null}}]" (click)="login()">
          <svg-icon key="login"></svg-icon>
          Login
        </a>
      </li>
    }
    @if (user?.claim?.contactID) {
      <li>
        <a [routerLink]="[{ outlets: { primary: [], actionbar: null}}]" (click)="logoutDialog.showModal()">
          <svg-icon key="logout"></svg-icon>
          Logout
        </a>
      </li>
    }
  </ul>

  <hr class="actions">

  <ul class="misc">
    @if (user?.hasAdminRole) {
      <li>
        <a [routerLink]="[{ outlets: { primary: ['fit-admin'], actionbar: null}}]"
          routerLinkActive="active-page" (click)="close()">
          <svg-icon key="gear-solid"></svg-icon>
          Admin
        </a>
      </li>
    }
    <li>
      <a [routerLink]="[{ outlets: { primary: ['data-extracts'], actionbar: null}}]"
        routerLinkActive="active-page" (click)="close()">
        <svg-icon key="data-extract"></svg-icon>
        Data Extracts
      </a>
    </li>
    <!--				<li>-->
    <!--					<a routerLink="/resources" routerLinkActive="active-page" (click)="close()">-->
    <!--						<svg-icon key="resources"></svg-icon>-->
    <!--						Resources-->
  <!--					</a>-->
<!--				</li>-->
<li>
  <a [routerLink]="[{ outlets: { primary: ['about'], actionbar: null}}]"
    routerLinkActive="active-page" (click)="close()">
    <svg-icon key="info-solid"></svg-icon>
    About
  </a>
</li>
<li>
  <a [routerLink]="[{ outlets: { primary: ['help'], actionbar: null}}]"
    routerLinkActive="active-page" (click)="close()">
    <svg-icon key="help"></svg-icon>
    Help
  </a>
</li>
@if(isDevelopment) {
  <li>
    <a [routerLink]="[{ outlets: { primary: ['style-guide'], actionbar: null}}]"
      routerLinkActive="active-page"
      (click)="close()">
      <svg-icon key="resources-info"></svg-icon>
      Style Guide
    </a>
  </li>
  <li>
    <a [routerLink]="[{ outlets: { actionbar: 'search-by-name'}}]"
      (click)="close()">
      <svg-icon key="resources-info"></svg-icon>
      Search By Name
    </a>
  </li>
  <li>
    <a [routerLink]="[{ outlets: { actionbar: 'omni-search'}}]"
      (click)="close()">
      <svg-icon key="resources-info"></svg-icon>
      Omni-Search
    </a>
  </li>
  <li>
    <a [routerLink]="[{ outlets: { actionbar: 'compare-governments'}}]"
      (click)="close()">
      <svg-icon key="resources-info"></svg-icon>
      Compare Governments
    </a>
  </li>
}

</ul>
</nav>

<div class="seal">
  <a href="https://sao.wa.gov/">
    <img class="horizontal" src="assets/seal-horizontal.svg" alt="Seal of the Office of the Washington State Auditor">
    <img class="vertical" src="assets/seal-vertical.svg" alt="Seal of the Office of the Washington State Auditor">
  </a>
</div>
</div>
</div>

<app-dialog #logoutDialog [showCloseButton]="true" title="Logout Confirmation" class="generic" aria-describedby="description">
  <p id="description">Please confirm you wish to logout as an authenticated user. After logout, you will be taken to the Explore page.</p>
  <ng-container class="actions">
    <button class="dialog-button large outline" (click)="logoutDialog.close()">
      Cancel
    </button>
    <button class="dialog-button large solid" autofocus=autofocus (click)="logout()">
      <svg-icon key="check"></svg-icon>
      Apply
    </button>
  </ng-container>
</app-dialog>



